import { getUserFavoritePins } from "@/services";
import { useMount, useSafeState } from "ahooks";
import { useCallback } from "react";
import PinList from "../../../PinList";
import Empty from "../Empty";
import Loading from "../Loading";

export default function MyFavoritePinList({ user, initLikesPins }) {
  const [loading, setLoading] = useSafeState(!initLikesPins);
  const [records, setRecords] = useSafeState(initLikesPins || []);
  const [hasMore, setHasMore] = useSafeState(true);

  const loadData = useCallback(
    async (currentRecords) => {
      setLoading(true);
      currentRecords = currentRecords || records;
      const PAGE_SIZE = 30;

      const params = {
        username: user.urlname,
        max: currentRecords[currentRecords.length - 1]?.seq,
        limit: PAGE_SIZE,
      };
      const { err, pins } = await getUserFavoritePins(params);
      setLoading(false);
      if (err) return;

      if (pins.length < PAGE_SIZE) setHasMore(false);

      setRecords([...currentRecords.concat(pins)]);
    },
    [records, setHasMore, setLoading, setRecords, user.urlname]
  );

  useMount(async () => {
    if (!initLikesPins || !initLikesPins.length) {
      await loadData([]);
    }
  });

  if (loading && !records.length) {
    return <Loading />;
  }

  return records.length ? (
    <PinList
      dataSource={records}
      onLoadMore={loadData}
      hasMore={hasMore}
      showLikeBtn
      hideUser
    />
  ) : (
    <Empty
      imageUrl={
        "https://cdn.dancf.com/fe-assets/img/e66686c56220ce789c966b6653936017.png"
      }
      title={"还没有喜欢的采集哦～"}
    />
  );
}
